import { useCallback, useEffect, useRef, useState } from 'react'
import { Howl, Howler } from 'howler'

export const useLoopForTwoSounds = (url, start, pageName, stopAll, crossfadeDuration = 3000, volume = 1) => {
  const [activeSoundLoaded, setActiveSoundLoaded] = useState(false)
  const [activeSound2Loaded, setActiveSound2Loaded] = useState(false)

  const [sound] = useState(
    () =>
      url &&
      new Howl({
        src: url,
        preload: true,
        html5: true,
        volume: 0,
        onload: () => {
          console.log('big bg file 1 loaded')
          setActiveSoundLoaded(true)
        },
      })
  )

  const [sound2] = useState(
    pageName !== 'wool' &&
      url &&
      new Howl({
        src: url,
        preload: false,
        // html5: true,
        volume: 0,
        onload: () => {
          console.log('big bg file 2 loaded')
          setActiveSound2Loaded(true)
        },
      })
  )

  useEffect(() => {
    return () => {
      clearTimeout(window.timerId)
      if (sound) {
        sound.fade(1, 0, crossfadeDuration)
        setTimeout(() => {
          sound.unload()
        }, crossfadeDuration)
      }
      if (sound2) {
        sound2.fade(1, 0, crossfadeDuration)
        setTimeout(() => {
          sound2.unload()
        }, crossfadeDuration)
      }
    }
  }, [])

  useEffect(() => {
    if (activeSoundLoaded && pageName !== 'wool') {
      sound2.load()
    }
  }, [activeSoundLoaded, pageName, sound2])

  useEffect(() => {
    console.log(activeSound2Loaded, 'sound2 loaded')
  }, [activeSound2Loaded])

  const prevSoundActive = useRef()

  const stop = useCallback(() => {
    clearTimeout(window.timerId)
    prevSoundActive.current = Howler._howls.find((howl) => !!Object.keys(howl._endTimers)[0])
    if (prevSoundActive.current) {
      prevSoundActive.current.fade(1, 0, crossfadeDuration)
      setTimeout(() => {
        prevSoundActive.current.stop()
      }, crossfadeDuration)
    }
  }, [crossfadeDuration])

  useEffect(() => {
    stop()
  }, [stop])

  useEffect(() => {
    if (stopAll) {
      stop()
    }
  }, [stopAll, stop])

  useEffect(() => {
    const crossfadedLoop = (enteringInstance, leavingInstance) => {
      if (enteringInstance) {
        // Fade in entering instance
        enteringInstance.fade(0, volume, crossfadeDuration)
        enteringInstance.play()

        // Wait for the audio end to fade out entering instance
        // white fading in leaving instance
        window.timerId = setTimeout(() => {
          enteringInstance.fade(volume, 0, crossfadeDuration)
          if (pageName !== 'wool') {
            crossfadedLoop(leavingInstance, enteringInstance)
          }
        }, enteringInstance._duration * 1000 - crossfadeDuration)
      }
    }

    if (start && activeSoundLoaded) {
      crossfadedLoop(sound, sound2)
    }
  }, [activeSoundLoaded, start, sound, sound2, crossfadeDuration, volume, pageName])

  return {
    activeSoundLoaded: !url ? true : activeSoundLoaded,
    activeSound2Loaded: !url || pageName === 'wool' ? true : activeSound2Loaded,
  }
}
